import { Injectable } from '@angular/core';
import {IAppConfig, IWebForms} from "./common.types";


@Injectable({
	providedIn: 'root'
})
export class AppConfigurationService {

	private config: IAppConfig;

	constructor() {
	}

	public loadConfig() {
		const data: IAppConfig = {
			externalAuthentication: window["__patient_portal_global_vars__"].externalAuthentication,
			useBackendExternalAuthentication: window["__patient_portal_global_vars__"].useBackendExternalAuthentication,
			externalLoginPageUrl: window["__patient_portal_global_vars__"].externalLoginPageUrl,
			AuthServerUrl: window["__patient_portal_global_vars__"].AuthServerUrl,
			WebApiUrl: window["__patient_portal_global_vars__"].WebApiUrl,
			webForms: {
				patientDetailsURL: window["__patient_portal_global_vars__"].webForms.patientDetailsURL,
				patientSearchURL: window["__patient_portal_global_vars__"].webForms.patientSearchURL,
				moreInfoURL: window["__patient_portal_global_vars__"].webForms.moreInfoURL,
				kioskManualIdUrl: window["__patient_portal_global_vars__"].webForms.kioskManualIdUrl
			}
		};
		this.config = new AppConfig(data);
	}


	get Config(): IAppConfig {
		return this.config;
	}
}

class AppConfig implements IAppConfig {
	constructor(other: IAppConfig) {
		this.externalAuthentication = other.externalAuthentication;
		this.useBackendExternalAuthentication = other.useBackendExternalAuthentication;
		if (window.location.host === 'localhost:4200') {
			this.WebApiUrl = other.WebApiUrl + '/api/';
			this.AuthServerUrl = other.AuthServerUrl;
			this.webForms = other.webForms;
			this.externalLoginPageUrl = other.externalLoginPageUrl;
		} else {
			this.WebApiUrl = window.location.origin + '/' + other.WebApiUrl + '/api/';
			this.AuthServerUrl = window.location.origin + '/' + other.AuthServerUrl;
			this.webForms = {
				patientSearchURL: window.location.origin + '/' + other.webForms.patientSearchURL,
				patientDetailsURL: window.location.origin + '/' + other.webForms.patientDetailsURL,
				moreInfoURL: window.location.origin + '/' + other.webForms.moreInfoURL,
				kioskManualIdUrl: window.location.origin + '/' + other.webForms.kioskManualIdUrl,
			};
			if (this.externalAuthentication === true) {
				this.externalLoginPageUrl = window.location.origin + '/' + other.externalLoginPageUrl;
			}
		}
	}

	AuthServerUrl: string;
	WebApiUrl: string;
	externalAuthentication: boolean;
	useBackendExternalAuthentication: boolean;
	externalLoginPageUrl: string;
	webForms: IWebForms;
}

